import classNames from 'classnames';
import { LegacyRef, TextareaHTMLAttributes, forwardRef } from 'react';

import s from './Input.module.css';

const TextArea = (
  { className, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement>,
  ref: LegacyRef<HTMLTextAreaElement>,
) => {
  return (
    <textarea className={`${classNames(s.control, className)} resize-none`} {...rest} ref={ref} />
  );
};

export default forwardRef(TextArea);
